const openExternalLink = (url: string, useCurrentPage = false) => {
  if (!window.ReactNativeWebView) {
    if (!useCurrentPage) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    window.location.href = url;
    return;
  }

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: 'OPEN_EXTERNAL_LINK',
      url: url,
    }),
  );
};

export default openExternalLink;
